module.exports = __webpack_public_path__ + "static/img/成果icon.d185432b.svg";